import { RoundCard } from "./RoundCard";
import { SubHeaderCard } from "../Components/SubHeaderCard";
import { Trans, useTranslation } from "@coworker/locales";
import styled from "styled-components";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { DIVISION_HASH, HEADER_COLOR_SCHEMA } from "../constants";
import { ActiveRoundObject, RoundCounts } from "../Types";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { checkActiveRoundFilter } from "../helper";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";

interface DivisionCardProps {
  round: string;
  title: string;
  roundCounts: RoundCounts | undefined;
  loading: boolean;
  activeRound: ActiveRoundObject;
  shoppingToolsFilters: FilterValue[];
}
const InlineMessageWrapper = styled("div")`
  padding: 0px 16px 16px 16px;
  background-color: var(--grey200);
`;
const Container = styled("div")`
  width: 100%;
`;

export const Round = ({
  round,
  title,
  roundCounts,
  loading,
  activeRound,
  shoppingToolsFilters,
}: DivisionCardProps) => {
  const navigate = useFixaNavigate();

  const activeArea =
    shoppingToolsFilters.find((filter) => filter.filterId === "area")?.value ??
    "wholeStore";

  const { t } = useTranslation();

  const isActiveRoundFilter = checkActiveRoundFilter(
    title,
    shoppingToolsFilters
  );

  const isWholeStore = activeArea === "wholeStore";
  const isShowroomOW = activeArea === "showroomOW";
  const isMarkethallOW = activeArea === "markethallOW";
  const isCashline = activeArea === "otherAreaCashline";

  return (
    <Container>
      {isActiveRoundFilter && (
        <>
          <SubHeaderCard
            title={<Trans>{title}</Trans>}
            fontSize={16}
            colorSchema={HEADER_COLOR_SCHEMA.GREY}
          />
          {!activeRound.isActiveRound ? (
            <InlineMessageWrapper>
              <FixaInlineMessage
                title={t("surveyAvailabilityString")}
                body={
                  t("onlyAvailableBetweenString") +
                  " " +
                  `${activeRound.startTime}-${activeRound.endTime}`
                }
                variant={"cautionary"}
              />
            </InlineMessageWrapper>
          ) : null}
          {(isShowroomOW || isWholeStore) && (
            <RoundCard
              title={DIVISION_HASH.SHOWROOM?.transKey}
              currentValue={roundCounts?.showroom}
              onClick={() =>
                navigate(`/shoppingtools/progress/showroom/${round}`)
              }
              loading={loading}
              activeRound={activeRound}
            />
          )}
          {(isMarkethallOW || isWholeStore) && (
            <RoundCard
              title={DIVISION_HASH.MARKETHALL?.transKey}
              currentValue={roundCounts?.markethall}
              onClick={() =>
                navigate(`/shoppingtools/progress/markethall/${round}`)
              }
              loading={loading}
              activeRound={activeRound}
            />
          )}
          {(isCashline || isWholeStore) && (
            <RoundCard
              title={DIVISION_HASH.CASHLINE?.transKey}
              currentValue={roundCounts?.cashline}
              onClick={() =>
                navigate(`/shoppingtools/progress/cashline/${round}`)
              }
              loading={loading}
              activeRound={activeRound}
            />
          )}
        </>
      )}
    </Container>
  );
};
